import {getUserId, CREDIT_PACKS, STRIPE_API_BASE} from "./CreditStore"

let stylesInjected = false

function injectStyles(): void {
    if (stylesInjected) return
    stylesInjected = true
    const style = document.createElement("style")
    style.id = "checkout-modal-styles"
    style.textContent = `
        @keyframes cm-fadeIn { from{opacity:0} to{opacity:1} }
        @keyframes cm-slideUp { from{opacity:0;transform:translateY(28px) scale(0.97)} to{opacity:1;transform:translateY(0) scale(1)} }
        @keyframes cm-shimmer { 0%{background-position:200% center} 100%{background-position:-200% center} }
        @keyframes cm-pulse-glow { 0%,100%{box-shadow:0 0 0 0 rgba(139,92,246,0)} 50%{box-shadow:0 0 30px 6px rgba(139,92,246,0.25)} }
        @keyframes cm-spin { to{transform:rotate(360deg)} }

        .cm-overlay { position:fixed;inset:0;z-index:10000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(3,3,8,0.92);backdrop-filter:blur(28px) saturate(140%);animation:cm-fadeIn 0.25s ease; }
        .cm-modal { font-family:system-ui,sans-serif;position:relative;background:linear-gradient(175deg,rgba(17,10,35,0.99) 0%,rgba(10,6,22,0.99) 100%);border:1px solid rgba(139,92,246,0.2);border-radius:28px;padding:0;width:min(540px,96vw);max-height:90vh;overflow-y:auto;overflow-x:hidden;box-shadow:0 0 80px rgba(109,40,217,0.25),0 32px 96px rgba(0,0,0,0.9),inset 0 1px 0 rgba(255,255,255,0.06);animation:cm-slideUp 0.38s cubic-bezier(0.22,1,0.36,1); }
        .cm-modal::-webkit-scrollbar{width:4px} .cm-modal::-webkit-scrollbar-track{background:transparent} .cm-modal::-webkit-scrollbar-thumb{background:rgba(139,92,246,0.3);border-radius:2px}
        .cm-close { position:absolute;top:16px;right:16px;z-index:2;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.08);color:rgba(255,255,255,0.4);font-size:18px;width:32px;height:32px;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;transition:all 0.2s;line-height:1; }
        .cm-close:hover { color:white;background:rgba(255,255,255,0.12); }

        .cm-hero { position:relative;overflow:hidden;padding:2.5rem 2.5rem 1.5rem;text-align:center;border-bottom:1px solid rgba(255,255,255,0.05); }
        .cm-hero-bg { position:absolute;inset:0;background:radial-gradient(ellipse 80% 120% at 50% -20%,rgba(109,40,217,0.18),transparent 70%);pointer-events:none; }
        .cm-hero-badge { display:inline-flex;align-items:center;gap:6px;background:rgba(139,92,246,0.12);border:1px solid rgba(139,92,246,0.25);border-radius:100px;padding:5px 12px;font-size:11px;font-weight:600;color:rgba(196,160,255,0.9);letter-spacing:0.06em;text-transform:uppercase;margin-bottom:1rem; }
        .cm-hero-badge-dot { width:6px;height:6px;border-radius:50%;background:hsl(270,85%,65%);animation:cm-pulse-glow 2s ease-in-out infinite; }
        .cm-hero-title { font-size:26px;font-weight:800;color:white;letter-spacing:-0.03em;line-height:1.15;margin:0 0 0.5rem; }
        .cm-hero-sub { font-size:13.5px;color:rgba(255,255,255,0.42);margin:0;line-height:1.5; }

        .cm-unlimited { margin:1.5rem 1.5rem 0;position:relative;overflow:hidden;border-radius:20px;border:1.5px solid rgba(139,92,246,0.5);background:linear-gradient(135deg,rgba(109,40,217,0.18),rgba(79,70,229,0.12));cursor:pointer;transition:all 0.22s ease; }
        .cm-unlimited:hover { border-color:rgba(167,139,250,0.7);transform:translateY(-2px);box-shadow:0 12px 40px rgba(109,40,217,0.3); }
        .cm-unlimited-inner { padding:1.25rem 1.5rem; }
        .cm-unlimited-top { display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:0.75rem; }
        .cm-unlimited-chip { display:inline-flex;align-items:center;gap:5px;font-size:10px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:hsl(270,85%,75%);background:rgba(139,92,246,0.15);border:1px solid rgba(139,92,246,0.3);border-radius:100px;padding:3px 10px;margin-bottom:6px; }
        .cm-unlimited-name { font-size:19px;font-weight:800;color:white;letter-spacing:-0.02em;margin:0; }
        .cm-unlimited-desc { font-size:12.5px;color:rgba(255,255,255,0.45);margin:4px 0 0; }
        .cm-unlimited-price { text-align:right;flex-shrink:0; }
        .cm-unlimited-amount { font-size:28px;font-weight:800;color:white;letter-spacing:-0.03em;line-height:1; }
        .cm-unlimited-period { font-size:11px;color:rgba(255,255,255,0.35);margin-top:2px; }
        .cm-unlimited-features { display:flex;flex-wrap:wrap;gap:6px; }
        .cm-unlimited-feat { display:inline-flex;align-items:center;gap:4px;font-size:11.5px;color:rgba(255,255,255,0.55);background:rgba(255,255,255,0.04);border-radius:6px;padding:3px 8px; }
        .cm-unlimited-feat-check { color:hsl(270,85%,70%);font-size:10px;font-weight:700; }
        .cm-unlimited-btn { width:100%;margin-top:1rem;padding:11px;border:none;border-radius:12px;background:linear-gradient(135deg,hsl(270,85%,58%),hsl(250,80%,55%));color:white;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer;transition:all 0.2s;letter-spacing:-0.01em;display:flex;align-items:center;justify-content:center;gap:8px; }
        .cm-unlimited-btn:hover { opacity:0.9;transform:translateY(-1px);box-shadow:0 6px 20px rgba(109,40,217,0.35); }
        .cm-unlimited-btn:disabled { opacity:0.5;cursor:not-allowed;transform:none; }
        .cm-unlimited-shimmer { position:absolute;inset:0;background:linear-gradient(105deg,transparent 20%,rgba(255,255,255,0.06) 50%,transparent 80%);background-size:200% 100%;animation:cm-shimmer 3s linear infinite; }

        .cm-divider { display:flex;align-items:center;gap:12px;margin:1.5rem 1.5rem 0;color:rgba(255,255,255,0.2);font-size:11.5px;letter-spacing:0.05em;text-transform:uppercase;font-weight:600; }
        .cm-divider::before,.cm-divider::after { content:'';flex:1;height:1px;background:rgba(255,255,255,0.07); }

        .cm-packs { display:flex;flex-direction:column;gap:8px;margin:1rem 1.5rem 0; }
        .cm-pack { display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 18px;border-radius:16px;border:1.5px solid rgba(255,255,255,0.07);background:rgba(255,255,255,0.025);cursor:pointer;transition:all 0.18s ease;position:relative;overflow:hidden; }
        .cm-pack:hover { border-color:rgba(139,92,246,0.4);background:rgba(139,92,246,0.06);transform:translateY(-1px);box-shadow:0 4px 16px rgba(109,40,217,0.15); }
        .cm-pack.featured { border-color:rgba(139,92,246,0.28);background:rgba(139,92,246,0.045); }
        .cm-pack-left { display:flex;flex-direction:column;gap:3px; }
        .cm-pack-label { font-size:15.5px;font-weight:700;color:rgba(255,255,255,0.9);letter-spacing:-0.01em; }
        .cm-pack-sub { font-size:11.5px;color:rgba(255,255,255,0.32); }
        .cm-pack-right { display:flex;align-items:center;gap:10px;flex-shrink:0; }
        .cm-pack-badge { font-size:9.5px;font-weight:700;letter-spacing:0.07em;text-transform:uppercase;padding:3px 8px;border-radius:100px;background:linear-gradient(135deg,hsl(270,85%,60%),hsl(220,80%,60%));color:white;white-space:nowrap; }
        .cm-pack-price { font-size:18px;font-weight:800;color:white;letter-spacing:-0.02em; }
        .cm-pack-btn { background:rgba(139,92,246,0.15);border:1px solid rgba(139,92,246,0.3);border-radius:10px;color:rgba(196,160,255,0.9);font-family:inherit;font-size:12.5px;font-weight:700;padding:7px 16px;cursor:pointer;transition:all 0.18s;white-space:nowrap; }
        .cm-pack-btn:hover { background:rgba(139,92,246,0.28);border-color:rgba(139,92,246,0.5);color:white; }
        .cm-pack-btn:disabled { opacity:0.4;cursor:not-allowed; }
        .cm-pack-spinner { width:14px;height:14px;border:2px solid rgba(139,92,246,0.3);border-top-color:hsl(270,85%,65%);border-radius:50%;animation:cm-spin 0.75s linear infinite;display:inline-block; }

        .cm-payments { display:flex;align-items:center;justify-content:center;gap:10px;margin:1.25rem 1.5rem 0;padding:10px;background:rgba(255,255,255,0.025);border-radius:12px;border:1px solid rgba(255,255,255,0.05); }
        .cm-payments-label { font-size:11px;color:rgba(255,255,255,0.3);font-weight:500; }
        .cm-payment-icon { display:flex;align-items:center;gap:4px;font-size:11px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.05);border-radius:6px;padding:3px 8px;font-weight:600; }

        .cm-trust { display:flex;align-items:center;justify-content:center;gap:16px;margin:1rem 1.5rem 1.5rem;flex-wrap:wrap; }
        .cm-trust-item { display:flex;align-items:center;gap:5px;font-size:11px;color:rgba(255,255,255,0.28);font-weight:500; }

        .cm-success-banner { position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:10001;display:flex;align-items:center;gap:10px;padding:12px 20px;background:rgba(34,197,94,0.12);border:1px solid rgba(34,197,94,0.3);border-radius:12px;font-size:13px;color:hsl(142,72%,65%);backdrop-filter:blur(12px); }
        .cm-error-banner { position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:10002;display:flex;align-items:center;gap:10px;padding:12px 20px;background:rgba(239,68,68,0.15);border:1px solid rgba(239,68,68,0.35);border-radius:12px;font-size:13px;color:hsl(0,80%,70%);backdrop-filter:blur(12px);white-space:nowrap; }
    `
    document.head.appendChild(style)
}

function showCheckoutError(message: string): void {
    const existing = document.getElementById("cm-error-banner")
    if (existing) existing.remove()
    injectStyles()
    const banner = document.createElement("div")
    banner.id = "cm-error-banner"
    banner.className = "cm-error-banner"
    banner.textContent = `⚠ ${message}`
    document.body.appendChild(banner)
    setTimeout(() => {
        banner.animate([{opacity: 1}, {opacity: 0}], {duration: 500, fill: "forwards"}).onfinish = () => banner.remove()
    }, 6000)
}

async function handleCheckout(packId: string, btn: HTMLButtonElement, originalContent: string): Promise<void> {
    btn.disabled = true
    btn.innerHTML = '<span class="cm-pack-spinner"></span>'
    try {
        const userId = getUserId()
        const resp = await fetch(`${STRIPE_API_BASE}/create-checkout-session`, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({packId, userId})
        })
        const data = await resp.json()
        if (data.url) {
            window.location.href = data.url
        } else {
            throw new Error(data.error || "Failed to create checkout session")
        }
    } catch (e: any) {
        console.error("Checkout error:", e)
        btn.disabled = false
        btn.innerHTML = originalContent
        showCheckoutError(e.message || "Payment unavailable. Please try again later.")
    }
}

export function showCheckoutModal(): void {
    injectStyles()

    const existing = document.getElementById("cm-overlay")
    if (existing) existing.remove()

    const overlay = document.createElement("div")
    overlay.className = "cm-overlay"
    overlay.id = "cm-overlay"

    const modal = document.createElement("div")
    modal.className = "cm-modal"

    // Close button
    const closeBtn = document.createElement("button")
    closeBtn.className = "cm-close"
    closeBtn.innerHTML = "&#215;"
    closeBtn.onclick = () => overlay.remove()
    modal.appendChild(closeBtn)

    // Hero section
    const hero = document.createElement("div")
    hero.className = "cm-hero"
    hero.innerHTML = `
        <div class="cm-hero-bg"></div>
        <div class="cm-hero-badge"><div class="cm-hero-badge-dot"></div>MusicFlow AI</div>
        <h2 class="cm-hero-title">Unlock More Generations</h2>
        <p class="cm-hero-sub">You've used your free credits for today. Upgrade or buy more to keep creating.</p>
    `
    modal.appendChild(hero)

    // Unlimited plan
    const unlimitedCard = document.createElement("div")
    unlimitedCard.className = "cm-unlimited"
    unlimitedCard.innerHTML = `
        <div class="cm-unlimited-shimmer"></div>
        <div class="cm-unlimited-inner">
            <div class="cm-unlimited-top">
                <div>
                    <div class="cm-unlimited-chip">Best Value</div>
                    <h3 class="cm-unlimited-name">Unlimited Plan</h3>
                    <p class="cm-unlimited-desc">400 AI generations/month &middot; fair use</p>
                </div>
                <div class="cm-unlimited-price">
                    <div class="cm-unlimited-amount">$399</div>
                    <div class="cm-unlimited-period">per month</div>
                </div>
            </div>
            <div class="cm-unlimited-features">
                <span class="cm-unlimited-feat"><span class="cm-unlimited-feat-check">&#10003;</span>400 gen/mo</span>
                <span class="cm-unlimited-feat"><span class="cm-unlimited-feat-check">&#10003;</span>Priority queue</span>
                <span class="cm-unlimited-feat"><span class="cm-unlimited-feat-check">&#10003;</span>All AI models</span>
                <span class="cm-unlimited-feat"><span class="cm-unlimited-feat-check">&#10003;</span>Cancel anytime</span>
            </div>
            <button class="cm-unlimited-btn">&#9889; Subscribe &mdash; $399/mo</button>
        </div>
    `
    const ulBtn = unlimitedCard.querySelector(".cm-unlimited-btn") as HTMLButtonElement
    ulBtn.onclick = (e) => {
        e.stopPropagation()
        handleCheckout("unlimited", ulBtn, "&#9889; Subscribe &mdash; $399/mo")
    }
    unlimitedCard.onclick = () => handleCheckout("unlimited", ulBtn, "&#9889; Subscribe &mdash; $399/mo")
    // Credit packs
    const packs = document.createElement("div")
    packs.className = "cm-packs"
    packs.style.marginTop = "1.5rem"

    for (const pack of CREDIT_PACKS) {
        const packEl = document.createElement("div")
        packEl.className = "cm-pack" + (pack.badge ? " featured" : "")

        const left = document.createElement("div")
        left.className = "cm-pack-left"
        left.innerHTML = `
            <div class="cm-pack-label">${pack.label}</div>
            <div class="cm-pack-sub">${pack.perCredit} &middot; never expire</div>
        `

        const right = document.createElement("div")
        right.className = "cm-pack-right"
        if (pack.badge) {
            right.innerHTML += `<span class="cm-pack-badge">${pack.badge}</span>`
        }
        right.innerHTML += `<span class="cm-pack-price">${pack.price}</span>`
        const btn = document.createElement("button")
        btn.className = "cm-pack-btn"
        btn.textContent = "Buy"
        right.appendChild(btn)

        packEl.appendChild(left)
        packEl.appendChild(right)

        btn.onclick = (e) => {
            e.stopPropagation()
            handleCheckout(pack.id, btn, "Buy")
        }
        packEl.onclick = () => handleCheckout(pack.id, btn, "Buy")

        packs.appendChild(packEl)
    }
    modal.appendChild(packs)

    // Divider
    const divider = document.createElement("div")
    divider.className = "cm-divider"
    divider.textContent = "or go unlimited"
    modal.appendChild(divider)

    modal.appendChild(unlimitedCard)

    // Payment methods
    const payments = document.createElement("div")
    payments.className = "cm-payments"
    payments.innerHTML = `
        <span class="cm-payments-label">Pay with</span>
        <span class="cm-payment-icon">Card</span>
        <span class="cm-payment-icon">Link</span>
        <span class="cm-payment-icon">Apple Pay</span>
        <span class="cm-payment-icon">Google Pay</span>
    `
    modal.appendChild(payments)

    // Trust signals
    const trust = document.createElement("div")
    trust.className = "cm-trust"
    trust.innerHTML = `
        <div class="cm-trust-item"><span>&#128274;</span> Secure via Stripe</div>
        <div class="cm-trust-item"><span>&#9889;</span> Instant activation</div>
        <div class="cm-trust-item"><span>&#9993;</span> No account needed</div>
    `
    modal.appendChild(trust)

    overlay.appendChild(modal)
    overlay.onclick = (e) => {
        if (e.target === overlay) overlay.remove()
    }
    document.body.appendChild(overlay)
}

export function showPaymentSuccessBanner(credits: number): void {
    injectStyles()
    const existing = document.getElementById("cm-success-banner")
    if (existing) existing.remove()

    const banner = document.createElement("div")
    banner.id = "cm-success-banner"
    banner.className = "cm-success-banner"
    banner.innerHTML = credits > 0
        ? `&#10003; <strong>${credits} credits</strong> added to your account!`
        : `&#10003; <strong>Unlimited plan</strong> activated!`

    document.body.appendChild(banner)
    banner.animate(
        [{opacity: 0, transform: "translateX(-50%) translateY(-10px)"}, {opacity: 1, transform: "translateX(-50%) translateY(0)"}],
        {duration: 400, easing: "ease-out", fill: "forwards"}
    )

    setTimeout(() => {
        banner.animate([{opacity: 1}, {opacity: 0}], {duration: 500, easing: "ease", fill: "forwards"}).onfinish = () => banner.remove()
    }, 5000)
}
